import { render, staticRenderFns } from "./ShowRelatorio.vue?vue&type=template&id=861affac&scoped=true"
import script from "./ShowRelatorio.vue?vue&type=script&lang=js"
export * from "./ShowRelatorio.vue?vue&type=script&lang=js"
import style0 from "./ShowRelatorio.vue?vue&type=style&index=0&id=861affac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861affac",
  null
  
)

export default component.exports